import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import ConfirmDialog from '../Components/ConfirmDialog';
import { verifyPassword } from '../Networking/APIClient';
import LanguageIcon from '@material-ui/icons/Language';
import SvgIcon from '@material-ui/core/SvgIcon';
import Divider from '@material-ui/core/Divider';
import LanguageSelectionDialog from '../Components/LanguageSelectionDialog';
import Logo from '../logo.png';

let t;
let self;

class Login extends React.Component {
    constructor(props) {
        super(props);
        self = this;

        this.state = {
            email: {
                value: '',
                error: false,
                helperText: ''
            },
            password: {
                value: '',
                error: false,
                helperText: ''
            },
            valueCode: {
                value: '',
                error: false,
                helperText: ''
            },

            initialCredentials: props.initialCredentials,
            automaticLogin: props.automaticLogin,

            showPassword: false,
            credentialsCorrect: false,
            readyToLogin: false,
            loggingIn: false,
            languageSelectionDialogOpen: false,
            purchaseDialogOpen: this.props.paymentStatus !== null ? true : false,
        }

        t = props.getTranslation;
        this.updatePage = props.updatePage;
        this.onCredentialsCorrect = props.onCredentialsCorrect;
    }

    getTitleText() {
        return this.props.paymentStatus === 'OK' ? t('payment_successful_title') : t('payment_failed_title');
    }

    getMessageText() {
        return this.props.paymentStatus === 'OK' ? t('payment_successful_message') : t('payment_failed_message');
    }

    getButtonText() {
        return t('ok');
    }

    onButtonClicked = e => {
        e.preventDefault();
        // Need to set payment status to null after ok, otherwise the dialog shows up each
        // time this page is opened.
        self.props.setPaymentStatus(null);
        // Hide dialog and remove the paymentStatus query string from the url
        const queryString = require('query-string');
        const parsed = queryString.parse(window.location.search);
        const hasMultipleGateways = parsed.hasMultipleGateways;
        const normalQuery = '?language=' + self.props.language + '&valueCode=' + parsed.valueCode;
        const multipleGatewaysQuery = '?language=' + self.props.language;
        window.history.replaceState({}, document.title, "/" + (hasMultipleGateways === 'true' ? multipleGatewaysQuery : normalQuery));
        const booleanValue = (parsed.automaticLogin === 'true');
        self.props.setAutomaticLogin(booleanValue);
    }

    handleLanguageClickOpen = () => {
        this.setState({
            languageSelectionDialogOpen: true,
        });
    };

    handleLanguageClickClose = value => {
        this.setState({ selectedValue: value, languageSelectionDialogOpen: false });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    onLoginClicked = e => {
        this.setState({
            loggingIn: true
        })
        if (e != null) {
            e.preventDefault();
        }

        // Don't bother making the call with empty inputs
        if (this.props.usingValueCode && this.state.valueCode.value === '') {
            return;
        }

        if (!this.props.usingValueCode && (this.state.email.value === '' || this.state.password.value === '')) {
            return;
        }

        // Tell main to show the full page loading circle.
        // It will be hidden once AccountOverview is mounted.
        this.props.setLoading(true);

        const onAccessGranted = function onAccessGranted(accessType) {
            // Set credentials in the Main.js class. Credentials will be input for most API methods
            self.onCredentialsCorrect(accessType, myCredentials);

            self.setState((prevState) => ({
                valueCode: {
                    value: prevState.valueCode.value,
                    error: false,
                    helperText: ''
                },
                email: {
                    value: prevState.email.value,
                    error: false,
                    helperText: ''
                },
                password: {
                    value: prevState.password.value,
                    error: false,
                    helperText: ''
                },
            }));
        }

        const onError = function onError(isValueCode) {
            self.props.setLoading(false);
            console.log("Login failed");
            if (isValueCode) {
                self.setState((prevState) => ({
                    valueCode: {
                        value: prevState.valueCode.value,
                        error: true,
                        helperText: t('invalid_value_code')
                    }
                }));
            } else {
                self.setState((prevState) => ({
                    email: {
                        value: prevState.email.value,
                        error: true,
                        helperText: t('wrong_email_or_password')
                    },
                    password: {
                        value: prevState.password.value,
                        error: true,
                        helperText: t('wrong_email_or_password')
                    },
                }));
            }
        }

        let myCredentials;
        if (this.props.usingValueCode) {
            myCredentials = {
                email: this.state.valueCode.value,
                password: 'NotASecret'
            }
        } else {
            myCredentials = {
                email: this.state.email.value.trim(),
                password: this.state.password.value
            }
        }

        // Call VerifyPassword. If credentials are correct, the user will be logged in
        verifyPassword(myCredentials, this.props.usingValueCode, onAccessGranted, onError);
    }

    onRecoveryClicked = e => {
        e.preventDefault();
        self.updatePage('recovery');
    }

    // Todo: clean up and remove this.
    componentDidUpdate(prevState) {
        if (this.state.readyToLogin && !this.state.loggingIn) {
            self.onLoginClicked();
        }
    }

    componentDidMount() {
        // Initial value code will be present if the user comes from the phone app.
        if (this.props.automaticLogin) {
            this.setState({
                valueCode: {
                    value: this.props.initialCredentials.email,
                    error: false,
                    helperText: ''
                },
                readyToLogin: true
            });
        }
    }

    onSignUpClicked = e => {
        e.preventDefault();
        self.updatePage('sign_up_login');
    }

    onUseValueCodeClicked = e => {
        e.preventDefault();
        self.props.setUsingValueCode(!self.props.usingValueCode);
    }

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            document.activeElement.blur();
        }
    }

    render() {
        const { classes, onClose, selectedValue, ...other } = this.props;
        const paymentStatusContent =
            <ConfirmDialog
                titleText={this.getTitleText()}
                messageText={this.getMessageText()}
                buttonText={this.getButtonText()}
                onButtonClicked={e => this.onButtonClicked(e)}
                open={this.state.purchaseDialogOpen}
            />;

        const emailPaswordContent =
            <form>
                <TextField style={topEditTextStyle}
                    id="email"
                    label={t('email')}
                    value={this.state.email.value}
                    error={this.state.email.error}
                    helperText={this.state.email.helperText}
                    onChange={this.handleChange('email')}
                    onKeyPress={e => this.onKeyPressed(e)}
                    margin="normal"
                />
                <br />
                <FormControl style={editTextStyle}>
                    <InputLabel htmlFor="adornment-password">{t('password')}</InputLabel>
                    <Input
                        id="adornment-password"
                        type={this.state.showPassword ? 'text' : 'password'}
                        value={this.state.password.value}
                        error={this.state.password.error}
                        onChange={this.handleChange('password')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={this.handleClickShowPassword}
                                    onMouseDown={this.handleMouseDownPassword}
                                >
                                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <Button type="submit" style={loginButtonStyle} variant="contained" color="primary" onClick={e => this.onLoginClicked(e)}>{t('log_in')}</Button>
            </form>;

        const valueCodeContent =
            <form>
                <TextField style={valueCodeEditTextStyle}
                    id="valueCode"
                    label={t('value_code')}
                    error={this.state.valueCode.error}
                    helperText={this.state.valueCode.helperText}
                    value={this.state.valueCode.value}
                    onChange={this.handleChange('valueCode')}
                    onKeyPress={e => this.onKeyPressed(e)}
                    margin="normal" />
                <Button type="submit" style={loginButtonStyle} variant="contained" color="primary" onClick={e => this.onLoginClicked(e)}>{t('log_in')}</Button>
            </form>;

        return (
            <div className="Login">
                {this.props.paymentStatus !== null ? paymentStatusContent : null}

                <Paper className="login-content-centered">
                    {/*
                     Title currently not used
                             <div className="login-title-container">
                        <Typography variant="title" color="primary" noWrap>
                            Sikom Kontoadministrasjon
                    </Typography>
                    </div>
                    */}

                    <div>
                        <img src={Logo} alt="Logo" className="Logo" />
                    </div>

                    {this.props.usingValueCode ? valueCodeContent : emailPaswordContent}
                    <div className="LoginButtonsContainer">
                        <div >
                            <Button style={useValueCodeButtonStyle} variant="text" color="secondary" onClick={e => this.onUseValueCodeClicked(e)}>
                                {this.props.usingValueCode ? t('use_email') : t('use_value_code')}
                            </Button>
                        </div>
                        <div>
                            <Button style={registerButtonStyle} variant="text" color="secondary" onClick={e => this.onSignUpClicked(e)}>
                                {t('sign_up')}
                            </Button>
                        </div>
                        <div>
                            <Button style={recoveryButtonStyle} variant="text" color="secondary" onClick={e => this.onRecoveryClicked(e)}>
                                {t('forgot_email_password')}
                            </Button>
                        </div>
                    </div>
                    <div className='bottom-container'>
                        <div>
                            <Button color="secondary" onClick={this.handleLanguageClickOpen}>
                                <LanguageIcon style={languageIconStyle} />
                                {this.props.language === 'nb-NO' ? 'Norsk' : 'English'}
                            </Button>
                            <LanguageSelectionDialog
                                selectedValue={this.state.selectedValue}
                                open={this.state.languageSelectionDialogOpen}
                                onClose={this.handleLanguageClickClose}
                                language={this.props.language}
                                setAndDownloadLanguage={this.props.setAndDownloadLanguage}
                            />
                        </div>
                    </div>
                </Paper>
            </div>



        );
    }
}

export default Login;

const languageIconStyle = {
    paddingRight: 10,
};

const loginButtonStyle = {
    marginTop: 30,
    position: "relative",
    width: "80%"
};

const useValueCodeButtonStyle = {
    marginTop: 10,
    position: "relative",
    width: "80%"
};

const registerButtonStyle = {
    marginTop: 10,
    position: "relative",
    width: "80%"
};

const recoveryButtonStyle = {
    marginTop: 80,
    position: "relative",
    width: "80%"
};

export const editTextStyle = {
    position: "relative",
    width: "80%"
}

const topEditTextStyle = {
    marginTop: 30,
    position: "relative",
    width: "80%"
}

const valueCodeEditTextStyle = {
    marginTop: 78,
    position: "relative",
    width: "80%"
}


// WEBPACK FOOTER //
// ./src/Pages/Login.js